import { render, staticRenderFns } from "./ConfirmDelivery.vue?vue&type=template&id=0146efd2"
import script from "./ConfirmDelivery.vue?vue&type=script&lang=js"
export * from "./ConfirmDelivery.vue?vue&type=script&lang=js"
import style0 from "./ConfirmDelivery.vue?vue&type=style&index=0&id=0146efd2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports